import { i18n } from "@/i18n";

export default {
  path: "/institution",
  name: "Institution",
  component: () => import(/* webpackChunkName: "institution" */ "@/views/Institution/InstitutionLayoutView.vue"),
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("page.institution_dashboard"),
  },
  children: [
    {
      path: "",
      name: "InstitutionList",
      component: () => import(/* webpackChunkName: "institution" */ "@/views/Institution/InstitutionListView.vue"),
      meta: {
        title: i18n.global.t("page.institution_list"),
        breadcrumb: true,
      },
    },
    {
      path: ":institutionId",
      name: "InstitutionDashboard",
      component: () => import(/* webpackChunkName: "institution" */ "@/views/Institution/InstitutionDashboardView.vue"),
      meta: {
        title: i18n.global.t("page.institution_dashboard"),
        breadcrumb: true,
      },
    },
  ],
};
